import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmBtn: {
    text: string;
    handler: any;
  };
  cancelBtn: {
    text: string;
    handler: any;
  };
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = props => {
  const [open, setOpen] = useState(props.open || false);
  const { t } = useTranslation();

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  return (
    <Dialog
      open={open}
      onClose={props.cancelBtn.handler}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{t(props.title)}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{t(props.description)}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.cancelBtn.handler} color="primary" variant="contained">
          {t(props.cancelBtn.text)}
        </Button>
        <Button onClick={props.confirmBtn.handler} color="primary" variant="contained">
          {t(props.confirmBtn.text)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
